import { CALL_API, successResponse, notSuccessResponse } from '../../../util/api'

export const getCleaningList = async (param) => {

    try {
        const response = await CALL_API.post('POS/cleaning/list', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

const getEwalletReport = async (param) => {

    try {
        const response = await CALL_API.post('Report/ewallet/report', param);
        return successResponse(response.data);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

const getClokInReport = async (param) => {

    try {
        const response = await CALL_API.post('Dashboard/ChekinCheckOut/Report', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}


const getCoinManagement = async (param) => {

    try {
        const response = await CALL_API.post('Dashboard/CoinManagement/Report', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}


const getMeterReport = async (param) => {

    try {
        const response = await CALL_API.post('Meter/MeterReportList', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}


const getPaymentRefund = async (param) => {

    try {
        const response = await CALL_API.post('Payment/Payment_Refund', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

const getPaymentTransaction = async (param) => {

    try {
        const response = await CALL_API.post('Payment/Web/GetPaymentTransaction', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}
const getReportPaymentTransaction = async (param) => {

    try {
        const response = await CALL_API.post('Payment/Report/GetPaymentTransaction', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}


const getPosReport = async (param) => {

    try {
        const response = await CALL_API.post('Report/pos/report', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

const getMachineHistoryReport = async (param) => {

    try {
        const response = await CALL_API.post('Report/machinehistory/report', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}



const getPosSummaryReport = async (param) => {

    try {
        const response = await CALL_API.post('Dashboard/Web/POSSummary', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

const getPosStatusLookup = async () => {

    try {
        const response = await CALL_API.post('Dashboard/Web/POSStatusLookup');
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

const getCustomerAddressByDeliveryID = async (param) => {

    try {
        const response = await CALL_API.post('Dashboard/Web/GetCustomerAddressByDeliveryId', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

const getLocationDetail = async (param) => {
    try {
        const response = await CALL_API.post('Location/List', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}

const getWDFServiceAvailability = async (param) => {

    try {
        const response = await CALL_API.post('WashDryFold/service/availability/web', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

const getPosSummaryReportDelivery = async (param) => {

    try {
        const response = await CALL_API.post('Dashboard/Web/POSSummaryDelivery', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

const getPosDetailJobStatus = async (param) => {

    try {
        const response = await CALL_API.post('Dashboard/JobStatus', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

const getDashboardVendingReport = async (param) => {

    try {
        const response = await CALL_API.post('Dashboard/Vending/Report', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

const getGasReport = async (param) => {

    try {
        const response = await CALL_API.post('Report/GasOrderReport', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

const getOtteriReport = async (param) => {

    try {
        const response = await CALL_API.post('Report/OtteriReport');
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

const getOtherReportName = async () => {

    try {
        const response = await CALL_API.post('Report/GetOtherReportName');
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

const getOtherReport = async (param) => {

    try {
        const response = await CALL_API.post('Report/LUOtherReport', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}


const getInternalReport = async (param) => {

    try {
        const response = await CALL_API.post('Report/LUReportByReportName', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}


const getClokInExport = async (param) => {

    try {
        const response = await CALL_API.post('report/clockin/clockout/report', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

const getWebIronOrderList = async (param) => {

    try {
        const response = await CALL_API.post('Ironing/web/order/list', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }

}

const getTrackingIronOrder = async (param) => {

    try {
        const response = await CALL_API.post('Ironing/web/order/tracking', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}

const rejectTrackingIronOrder = async (param) => {

    try {
        const response = await CALL_API.post('Ironing/order/status/reject', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}

const getIroingServiceReport = async (param) => {

    try {
        const response = await CALL_API.post('Report/Ironing/Service/Report', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}

const getSSRSSubscriptionReport = async (param) => {

    try {
        const response = await CALL_API.post('Report/ssrs/subscription/report', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}

const getProductLookup = async (param) => {

    try {
        const response = await CALL_API.post('MasterProduct/Lookup', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}

const getSellingProductProductLookup = async () => {
    try {
        const response = await CALL_API.post('Report/SellingProduct/ProductLookup');
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}

const getSellingProductSellingPointLookup = async () => {
    try {
        const response = await CALL_API.post('Report/SellingProduct/SellingPointLookup');
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}

const getSellingProductList = async (param) => {

    try {
        const response = await CALL_API.post('Report/SellingProduct/List', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}

const getSellingProductReport = async (param) => {

    try {
        const response = await CALL_API.post('Report/SellingProduct/Report', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}

const getWdfServiceTypeLov = async () => {
    try {
        const response = await CALL_API.post('Collection/GetListOfValueByType', { search: 'WDF_SERVICE_TYPE' });
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}

const updateTrackingStep = async (param) => {
    try {
        const response = await CALL_API.post('WashDryFold/web/update-tracking-step', param);
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}


const uploadDeliveryImageB64 = async (b64) => {
    try {
        const response = await CALL_API.post('File/upload/b64', { p: 'DELIVERY', b64 });
        return successResponse(response);
    } catch (error) {
        return notSuccessResponse(error);
    }
}

export {
    getEwalletReport,
    getClokInReport,
    getCoinManagement,
    getMeterReport,
    getPaymentRefund,
    getPaymentTransaction,
    getPosReport,
    getPosSummaryReport,
    getPosStatusLookup,
    getPosDetailJobStatus,
    getDashboardVendingReport,
    getGasReport,
    getMachineHistoryReport,
    getOtteriReport,
    getOtherReportName,
    getOtherReport,
    getInternalReport,
    getReportPaymentTransaction,
    getClokInExport,
    getWebIronOrderList,
    getTrackingIronOrder,
    rejectTrackingIronOrder,
    getIroingServiceReport,
    getSSRSSubscriptionReport,
    getPosSummaryReportDelivery,
    getCustomerAddressByDeliveryID,
    getWDFServiceAvailability,
    getLocationDetail,
    getProductLookup,
    getSellingProductProductLookup,
    getSellingProductSellingPointLookup,
    getSellingProductList,
    getSellingProductReport,
    getWdfServiceTypeLov,
    updateTrackingStep,
    uploadDeliveryImageB64
}